module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLeft) ? _c('section', {
    staticClass: "hand"
  }, [_c('h4', {
    staticClass: "hand-tittle"
  }, [_vm._v("Mão Esquerda")]), _vm._v(" "), _c('div', {
    staticClass: "finger-box"
  }, [_c('img', {
    staticClass: "base-image",
    attrs: {
      "alt": "left hand image",
      "src": require("../../../static/img/fingers/left-hand.svg")
    }
  }), _vm._v(" "), (_vm.LeftThumb) ? _c('img', {
    attrs: {
      "id": "left-thumb",
      "alt": "left thumb finger",
      "src": require("../../../static/img/fingers/left-thumb.svg")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.LeftIndexFinger) ? _c('img', {
    attrs: {
      "id": "left-index",
      "alt": "left index finger",
      "src": require("../../../static/img/fingers/left-index.svg")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.LeftMiddleFinger) ? _c('img', {
    attrs: {
      "id": "left-middle",
      "alt": "left middle finger",
      "src": require("../../../static/img/fingers/left-middle.svg")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.LeftRingFinger) ? _c('img', {
    attrs: {
      "id": "left-ring",
      "alt": "left ring finger",
      "src": require("../../../static/img/fingers/left-ring.svg")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.LeftLittleFinger) ? _c('img', {
    attrs: {
      "id": "left-little",
      "alt": "left little finger",
      "src": require("../../../static/img/fingers/left-little.svg")
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.isRight) ? _c('section', {
    staticClass: "hand"
  }, [_c('h4', {
    staticClass: "hand-tittle"
  }, [_vm._v("Mão Direita")]), _vm._v(" "), _c('div', {
    staticClass: "finger-box"
  }, [_c('img', {
    staticClass: "base-image",
    attrs: {
      "alt": "right hand image",
      "src": require("../../../static/img/fingers/right-hand.svg")
    }
  }), _vm._v(" "), (_vm.RightThumb) ? _c('img', {
    attrs: {
      "id": "right-thumb",
      "alt": "right thumb finger",
      "src": require("../../../static/img/fingers/left-thumb.svg")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.RightIndexFinger) ? _c('img', {
    attrs: {
      "id": "right-index",
      "alt": "right index finger",
      "src": require("../../../static/img/fingers/left-index.svg")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.RightMiddleFinger) ? _c('img', {
    attrs: {
      "id": "right-middle",
      "alt": "right middle finger",
      "src": require("../../../static/img/fingers/left-middle.svg")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.RightRingFinger) ? _c('img', {
    attrs: {
      "id": "right-ring",
      "alt": "right ring finger",
      "src": require("../../../static/img/fingers/left-ring.svg")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.RightLittleFinger) ? _c('img', {
    attrs: {
      "id": "right-little",
      "alt": "right little finger",
      "src": require("../../../static/img/fingers/left-little.svg")
    }
  }) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f7b5812"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/interfaces/components/HandFrame.vue
// module id = 253
// module chunks = 0